"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.roomPreferenceOptions = void 0;
const borough_dto_1 = require("../borough.dto");
const boroughPreferenceOptions = borough_dto_1.boroughsDto;
exports.roomPreferenceOptions = [
    'studio',
    'one-bedroom',
    'two-bedrooms',
    'three-bedrooms',
    'four-or-more-bedrooms',
];
